/**
 * Уникальные отсортированные биржи потока, плюс текущая биржа (правки или
 * применённого фильтра), если её там нет. Общий для формы правила алерта и
 * фильтров библиотеки.
 */
export function exchangeOptions(
  streamExchanges: readonly string[],
  current: string | null,
): string[] {
  const set = new Set(streamExchanges);
  if (current !== null) {
    set.add(current);
  }
  return Array.from(set).sort();
}
